// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  } */
  /* body {
    margin: 0;
    padding: 0;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background: #f1f1f1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 100vh;
  } */
  .imgLoad {
    max-width: 75%;
    margin: 20px;
  }
  a {
    text-decoration: none;
  }
  .file-upload {
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    background-color: #fff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    width:100%;
    /* max-width: 800px; */
    position: relative;
    margin-top: 2rem;
  }
  /* .file-upload::after {
    content: "😷 😁 👨‍💻";
    position: absolute;
    font-size: 5rem;
    top: -18%;
    left: 0;
    right: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .file-upload:hover::after {
    content: "🤘 😎 🤘";
  } */
  .file-upload h2 {
    font-size: 1.5rem;
    color: #333;
    position: relative;
    padding-right: 1rem;
    margin-bottom: 1rem;
  }
  .file-upload p {
    font-size: 0.875rem;
    color: #ddd;
    margin-bottom: 1rem;
  }
  .custom-form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.875rem;
  }
  .custom-form-group input {
    padding: 0.875rem 1rem;
    border-radius: 5px;
    border: 1px solid #ddd;
    color: #333;
    outline: none;
    transition: 0.3s ease-in-out;
    font-size: 0.875rem;
  }
  .custom-form-group input:focus {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  .custom-file-drop-area {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ddd;
    height: 200px;
    cursor: grab;
  }
  .custom-file-drop-area label {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 1.2rem;
    color: #3333;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
  }
  .custom-file-drop-area input {
    display: none;
  }
  .custom-file-drop-area.highlight {
    border-color: blue;
  }
  .custom-file-drop-area.highlight label {
    color: blue;
  }
  .custom-file-drop-area.redlight {
    border-color: red;
  }
  .custom-file-drop-area.redlight label {
    color: red;
  }

  .custom-file-preview {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-auto-rows: 200px;
    margin: 0.5rem;
    gap: 10px;
  }
  .custom-file-preview .prev-img {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
  }
  .custom-file-preview .prev-img span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    cursor: pointer;
    color: #333;
    font-size: 0.87rem;
    padding-bottom: 0.1rem;
    width: 20px;
    height: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    display: none;
  }
  .custom-file-preview .prev-img img {
    object-fit: cover;
    width: 100%;
    /* height:100%; */
  }
  .custom-file-preview .prev-img:hover span {
    display: flex;
  }
  .custom-file-preview .prev-img:hover::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .btn-submit {
    display: flex;
    width: 100px;
    align-items: center;
    justify-content: center;
    background-color: #333;
    color: #f1f1f1;
    font-size: 0.875rem;
    text-transform: uppercase;
    padding: 0.875rem 1.5rem;
    outline: none;
    -webkit-user-select: none;
    user-select: none;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  }`, "",{"version":3,"sources":["webpack://./src/includes/pageInside/imagesLoading.css"],"names":[],"mappings":"AAAA;;;;;KAKK;EACH;;;;;;;;;;;;;;;KAeG;EACH;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IAGE,aAAa;IAIb,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IAEtB,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;;;;;;;;;;;;;;;;;;;KAmBG;EACH;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;EACA;IAGE,aAAa;IAIb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IAEb,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IAEE,wCAAwC;EAC1C;EACA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IAEb,YAAY;EACd;EACA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;;EAEA;IAEE,aAAa;IAEb,4DAA4D;IAC5D,qBAAqB;IACrB,cAAc;IACd,SAAS;EACX;EACA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAET,gCAAgC;IAChC,UAAU;IACV,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,sBAAsB;IAGtB,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;EACA;IAEE,iBAAiB;IACjB,WAAW;IACX,iBAAiB;EACnB;EACA;IAGE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,oCAAoC;EACtC;EACA;IAGE,aAAa;IACb,YAAY;IAGZ,mBAAmB;IAGnB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IAGzB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IAEf,0CAA0C;EAC5C","sourcesContent":["/* * {\n    margin: 0;\n    padding: 0;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  } */\n  /* body {\n    margin: 0;\n    padding: 0;\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    background: #f1f1f1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    height: 100vh;\n  } */\n  .imgLoad {\n    max-width: 75%;\n    margin: 20px;\n  }\n  a {\n    text-decoration: none;\n  }\n  .file-upload {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding: 1.5rem;\n    background-color: #fff;\n    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n    width:100%;\n    /* max-width: 800px; */\n    position: relative;\n    margin-top: 2rem;\n  }\n  /* .file-upload::after {\n    content: \"😷 😁 👨‍💻\";\n    position: absolute;\n    font-size: 5rem;\n    top: -18%;\n    left: 0;\n    right: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n  .file-upload:hover::after {\n    content: \"🤘 😎 🤘\";\n  } */\n  .file-upload h2 {\n    font-size: 1.5rem;\n    color: #333;\n    position: relative;\n    padding-right: 1rem;\n    margin-bottom: 1rem;\n  }\n  .file-upload p {\n    font-size: 0.875rem;\n    color: #ddd;\n    margin-bottom: 1rem;\n  }\n  .custom-form-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 0.875rem;\n  }\n  .custom-form-group input {\n    padding: 0.875rem 1rem;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n    color: #333;\n    outline: none;\n    -webkit-transition: 0.3s ease-in-out;\n    transition: 0.3s ease-in-out;\n    font-size: 0.875rem;\n  }\n  .custom-form-group input:focus {\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  .custom-file-drop-area {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border: 2px dashed #ddd;\n    height: 200px;\n    cursor: -webkit-grab;\n    cursor: grab;\n  }\n  .custom-file-drop-area label {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    font-size: 1.2rem;\n    color: #3333;\n    text-transform: uppercase;\n    text-align: center;\n    font-weight: bold;\n  }\n  .custom-file-drop-area input {\n    display: none;\n  }\n  .custom-file-drop-area.highlight {\n    border-color: blue;\n  }\n  .custom-file-drop-area.highlight label {\n    color: blue;\n  }\n  .custom-file-drop-area.redlight {\n    border-color: red;\n  }\n  .custom-file-drop-area.redlight label {\n    color: red;\n  }\n\n  .custom-file-preview {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: (minmax(200px, 1fr)) [auto-fill];\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    grid-auto-rows: 200px;\n    margin: 0.5rem;\n    gap: 10px;\n  }\n  .custom-file-preview .prev-img {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    position: relative;\n    border-radius: 5px;\n    overflow: hidden;\n  }\n  .custom-file-preview .prev-img span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    z-index: 2;\n    cursor: pointer;\n    color: #333;\n    font-size: 0.87rem;\n    padding-bottom: 0.1rem;\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border-radius: 50px;\n    display: none;\n  }\n  .custom-file-preview .prev-img img {\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n    /* height:100%; */\n  }\n  .custom-file-preview .prev-img:hover span {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .custom-file-preview .prev-img:hover::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n  .btn-submit {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100px;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    background-color: #333;\n    color: #f1f1f1;\n    font-size: 0.875rem;\n    text-transform: uppercase;\n    padding: 0.875rem 1.5rem;\n    outline: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
